import {Component, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {ReactiveFormsModule, UntypedFormBuilder, Validators} from '@angular/forms';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule
  ],
  template: `
    <div class="hero min-h-screen bg-base-200">
      <div class="hero-content flex-col w-full max-w-sm">

        <!-- Logo -->
        <img
          src="logo.png"
          alt="Prezzemolo & Vitale"
          class="w-64 mb-2"
        />

        <!-- Login Card -->
        <div class="card bg-base-100 w-full shadow-2xl">
          <div class="card-body">
            <h2 class="text-2xl font-light tracking-widest text-center text-base-content/70 uppercase mb-4">Accedi</h2>

            <fieldset class="fieldset" [formGroup]="form">
              <label class="label" for="username">Username</label>
              <input
                id="username"
                type="text"
                class="input input-bordered w-full"
                placeholder="Inserisci il tuo username"
                autocomplete="username"
                formControlName="username"
              />

              <label class="label mt-3" for="password">Password</label>
              <input
                id="password"
                type="password"
                class="input input-bordered w-full"
                placeholder="Inserisci la tua password"
                autocomplete="current-password"
                formControlName="password"
              />

              <button class="btn btn-primary w-full mt-4" type="button" (click)="onLogin()">
                Accedi
              </button>
              @if (error() === 401) {
                <div class="alert alert-error mb-3" role="status" aria-live="polite">
                  Credenziali errate
                </div>
              } @else if (error()) {
                <div class="alert alert-error mb-3" role="status" aria-live="polite">
                  Errore generico
                </div>
              }
            </fieldset>
          </div>
        </div>

      </div>
    </div>
  `,
  styles: ``
})
export class LoginComponent {
  private router = inject(Router);
  private auth = inject(AuthService);
  private formBuilder = inject(UntypedFormBuilder);
  public error = signal<number|null>(null);
  public toast = inject(ToastService);

  public form = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  })

  public redirectUrl = 'home/qr-code';

  onLogin(): void {
    if (this.form.valid){
      this.error.set(null);
      this.auth.login(this.form.value.username, this.form.value.password).subscribe({
        next: (result) => {
          if (!this.auth.storeSession(result.data)) {
            this.toast.show('Token di accesso non ricevuto', 'error');
            return;
          }

          this.router.navigate([this.redirectUrl]);
        },
        error: (error) => {
          if (error.status == 401){
            this.toast.show('Credenziali errate', 'error');
          }
          else {
            this.toast.show('Errore generico', 'error');
          }
        }
      });
    }
  }
}
